import { Component, OnInit } from '@angular/core';
// import { PaymentService } from '../../../../services/payment.service';
import { ViewChild, ElementRef } from '@angular/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'ngx-card-pay',
  templateUrl: './card-pay.component.html',
  styleUrls: ['./card-pay.component.scss']
})
export class CardPayComponent implements OnInit {
  cardType: string = '';
  cardNumber: string = '';
  expiryDate: string = '';
  cvv: string = '';
  cardHolderName: string = '';
  amount: string = '';
  @ViewChild('cvvNumber') inputElement!: ElementRef;


  constructor(
    // public paymentService: PaymentService
  ) { }
 
  ngOnInit(): void { 
  }

  onCardPay() {
    // this.paymentService.chargeCreditCard( this.cardNumber, this.expiryDate, this.cvv).then((result:any) => {
    //     // Swal.fire({
    //     //   title: 'Error',
    //     //   text: JSON.stringify(result, null, 2),
        // })

        // alert(JSON.stringify(result, null, 2))
    // })
  }

  onCardTap() {
    this.cardNumber = '370000000000002';
    this.expiryDate = '2025-12';
    this.cvv = '';
    this.cardHolderName = 'John Doe';
    this.amount = '5';

    this.inputElement.nativeElement.focus();
  }



}
